import { getOrRefreshFcmToken } from "../firebaseMessaging";
import { registerDeviceAction } from "../ustils/actioncreator";
import { getDeviceRegistrationPayload, isAdminLoggedIn } from "../utils/deviceInfo";

let lastRegisteredToken = "";

/**
 * Register device with backend. Fetches FCM token when possible.
 * @param {string} [deviceToken] - explicit token, else reads localStorage / fetches FCM
 * @param {{ requestFcm?: boolean, skipIfNoToken?: boolean }} [options]
 */
export function registerAdminDeviceInBackground(deviceToken, options = {}) {
  const { requestFcm = false, skipIfNoToken = false } = options;
  if (!isAdminLoggedIn()) return;

  (async () => {
    let token = deviceToken || localStorage.getItem("fcmToken") || "";

    if (!token && requestFcm) {
      token = (await getOrRefreshFcmToken({ requestPermission: true })) || "";
      if (token) {
        localStorage.setItem("fcmToken", token);
        console.log("[Device] FCM token obtained for register-device");
      }
    }

    if (!token && skipIfNoToken) {
      console.warn("[Device] Skipping register-device — no FCM token yet (enable notifications)");
      return;
    }

    // Avoid duplicate API calls with the same token
    if (token && token === lastRegisteredToken) {
      console.log("[Device] Already registered with this FCM token");
      return;
    }

    const payload = getDeviceRegistrationPayload(token);
    console.log("[Device] register-device payload:", payload);

    if (!payload.device_token) {
      console.warn(
        "[Device] device_token is empty. Grant notification permission after login or click bell → Enable notifications."
      );
    }

    const res = await registerDeviceAction(payload);
    console.log("[Device] register-device success:", res);
    if (payload.device_token) {
      lastRegisteredToken = payload.device_token;
    }
  })().catch((err) => {
    console.warn(
      "[Device] register-device failed (background):",
      err?.response?.data?.message || err?.response?.data || err?.message || err
    );
  });
}

/** Call right after login while user gesture is still active — best chance to get FCM token. */
export async function registerAdminDeviceAfterLogin() {
  if (!isAdminLoggedIn()) return;

  const token = (await getOrRefreshFcmToken({ requestPermission: true })) || "";
  if (token) {
    localStorage.setItem("fcmToken", token);
  }
  registerAdminDeviceInBackground(token, { skipIfNoToken: false });
}
